import React, { useState, useRef } from "react";
import {
  Box,
  Typography,
  Slider,
  TextareaAutosize,
  Button,
  IconButton,
  Card,
  Chip,
  Tooltip,
  ButtonGroup,
  Grow,     // <-- Required
  Popper,            // <-- Required
  MenuList,          // <-- Required
  Paper,             // <-- Required
  ClickAwayListener, // <-- Required
  MenuItem           // <-- Required
} from '@mui/material';
import {
  Language,
  Send,
  LocationOn,
} from '@mui/icons-material';
import BotCard from './BotCard';
import AlarmAddIcon from '@mui/icons-material/AlarmAdd';
import ScheduleModal from '../ScheduleModal';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { toast } from 'react-toastify';
import { getAvatarByGender } from "../../../utils/CommonUtils";
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const ChatInitiation = ({
  selectedBot,
  selectedUser,
  messageTemplate,
  setMessageTemplate,
  onCancel,
  onInitiateChat,
  onBotClick,
  onRealUserClick,
  onBotViewButtonClick,
  onBotSelect,
  selectedUserId
}) => {
  const [openScheduleModal, setOpenScheduleModal] = useState(false);
  const handleScheduleSelect = (time) => {
    if (messageTemplate.trim() === '') {
      toast.error('Please enter a message first');
      return;
    }
    onInitiateChat(time);
    setOpenScheduleModal(false);
  };


  // For Split Button Dropdown
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const handleSend = () => {
    if (messageTemplate.trim() === '') {
      toast.error('Please enter a message first');
      return;
    }
    onInitiateChat();
  }


  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      {/* Selected User Card */}
      <Card sx={{ borderRadius: 3, border: '1px solid', borderColor: '#916008', bgcolor: 'rgba(25, 118, 210, 0.04)' }}>
        <Box sx={{ p: 3 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 3, flex: 1 }}>
              {/* Avatar with status */}
              <Box sx={{ position: 'relative' }}>
                <img
                  src={selectedUser.profilePicture || getAvatarByGender(selectedUser.gender)}
                  alt={(selectedUser.firstName ?? selectedUser.userName) || 'User'}
                  style={{
                    width: 72,
                    height: 72,
                    borderRadius: '50%',
                    objectFit: 'cover'
                  }}
                />
                <Box
                  sx={{
                    position: 'absolute',
                    bottom: 2,
                    right: 2,
                    width: 16,
                    height: 16,
                    bgcolor: selectedUser.isOnLine ? 'success.main' : 'grey.500',
                    borderRadius: '50%',
                    border: '2px solid white'
                  }}
                />
              </Box>

              {/* User Info */}
              <Box sx={{ flex: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyItems: 'center', gap: 2, mb: 1 }}>
                    <Typography sx={{ color: '#3C4043', fontSize: '18px', fontWeight: '600', mb: 0 }}>
                    {selectedUser?.firstName ?? selectedUser.userName}
                  </Typography>
                    <Box sx={{ color: selectedUser?.appInstalled ? '#108523' : '#fc2323', display: 'flex', alignItems: 'center', gap: 2 }}>{selectedUser?.appInstalled ? <Box><CheckCircleIcon sx={{ color: '#09a323' }} /> App Installed</Box> : <Box><CancelIcon />App Not Installed</Box>}</Box>
                  </Box>
                  {/* {selectedUser.plan && (
                    <Chip
                      label={selectedUser.plan === "gold" ? "Gold" : "Luxury"}
                      size="small"
                      sx={{
                        background:
                          selectedUser.plan === "gold"
                            ? 'linear-gradient(45deg, #916008, #cc9933)'
                            : 'linear-gradient(90deg, rgb(176, 37, 33) 0%, rgb(234, 67, 53) 100%)',
                        color: 'white',
                        fontSize: '12px',
                        textTransform: 'capitalize',
                        height: 25
                      }}
                    />
                  )} */}
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                  <LocationOn sx={{ fontSize: 16, color: 'text.secondary' }} />
                  <Typography variant="body2" sx={{ fontFamily: 'Neue Montreal, sans-serif', color: 'text.secondary' }}>
                    {`${selectedUser.city}, ${selectedUser.country}`}
                  </Typography>
                </Box>

                {/* <Typography variant="body2" sx={{ fontFamily: 'Neue Montreal, sans-serif', color: 'text.secondary' }}>
                  {selectedUser.status}
                </Typography> */}
              </Box>
            </Box>

            {/* Selected Badge */}
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 1 }}>
              {/* <Chip
                label="Selected"
                color="primary"
                size="small"
                sx={{ fontWeight: '500', fontSize: '14px', color: '#fff', background: '#916008' }}
              /> */}
              <Typography variant="caption" color="text.secondary">
                {selectedUser.status}
              </Typography>
              <Button onClick={onRealUserClick} sx={{ textTransform: 'capitalize', fontSize: '12px', background: '#BE1F1F', color: '#fff', borderRadius: '20px', px: 2, '&:hover': { background: '#ff4A4A' } }}>View Profile</Button>
            </Box>
          </Box>
        </Box>
      </Card>

      {/* Bot Selection Section */}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, border: '1px solid #ccc', p: 2, borderRadius: 2, }}>
        <Box>
          <Typography sx={{ fontWeight: 600, fontSize: '16px', color: '#000', }}>
            Selected Bot User
          </Typography>
        </Box>
        {/* Selected Bot Card */}
        <BotCard
          bot={selectedBot}
          selected={true}
          onBotClick={onBotClick}
          onClick={onBotSelect}
          onBotViewButtonClick={onBotViewButtonClick}
          selectedUserId={selectedUserId}
        />
        {/* Initial Message */}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Typography sx={{ fontWeight: 600, fontSize: '14px', color: '#3C4043', }}>
            Initial Message
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'end', gap: 2 }}>
            <TextareaAutosize className='msg-textarea'
              placeholder="Type your message here..."
              value={messageTemplate}
              onChange={(e) => setMessageTemplate(e.target.value)}
              style={{
                minHeight: 100,
                width: '100%',
                padding: '12px',
                borderRadius: '8px',
                border: '1px solid #ccc',
                background: '#F9FAFB',
                fontFamily: 'Plus Jakarta Sans, sans-serif',
                fontSize: '12px',
                resize: 'vertical',
                '&:placeholder': {
                  fontSize: '12px !important',
                  color: '#9CA3AF',
                }
              }}
            />
            {/* Action Buttons */}

            {/* Action Buttons */}
            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end', pt: 2 }}>

              {/* CANCEL BUTTON */}
              <Button
                onClick={onCancel}
                variant="outlined"
                sx={{
                  px: 3,
                  border: '1px solid rgba(0, 0, 0, 0.1)',
                  borderRadius: '12px',
                  textTransform: 'capitalize',
                  color: '#0A0A0A',
                }}
              >
                Cancel
              </Button>

              {/* --- SPLIT BUTTON GROUP (Initiate Chat + Schedule Message Dropdown) --- */}
              <Box>
                <ButtonGroup
                  variant="contained"
                  ref={anchorRef}
                  sx={{
                    borderRadius: "12px",
                    bgcolor: "#916008",
                  }}
                >
                  {/* MAIN BUTTON */}
                  <Button
                    onClick={() => handleSend()}
                    sx={{
                      px: 2.5,
                      textTransform: "capitalize",
                      fontSize: "14px",
                      bgcolor: "#916008",
                      "&:hover": { bgcolor: "warning.dark" }
                    }}
                  >
                    Send
                  </Button>

                  {/* DROPDOWN BUTTON */}
                  <Tooltip title="Schedule Message"> <Button
                    size="small"
                    onClick={handleToggle}
                    sx={{
                      px: 1,
                      minWidth: "40px",
                      bgcolor: "#916008",
                      "&:hover": { bgcolor: "warning.dark" }
                    }}
                  >
                    <KeyboardArrowUpIcon />
                  </Button></Tooltip>
                </ButtonGroup>

                {/* MENU POPPER */}
                <Popper
                  sx={{ zIndex: 10 }}
                  open={open}
                  anchorEl={anchorRef.current}
                  role={undefined}
                  transition
                  disablePortal
                >
                  {({ TransitionProps }) => (
                    <Grow
                      {...TransitionProps}
                      style={{ transformOrigin: "center top" }}
                    >
                      <Paper>
                        <ClickAwayListener onClickAway={handleClose}>
                          <MenuList autoFocusItem>

                            {/* Schedule Message Action */}
                            <MenuItem
                              onClick={() => {
                                setOpenScheduleModal(true);
                                setOpen(false);
                              }}
                            >
                              <AlarmAddIcon sx={{ mr: 1 }} /> Schedule Message
                            </MenuItem>
                          </MenuList>
                        </ClickAwayListener>
                      </Paper>
                    </Grow>
                  )}
                </Popper>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <ScheduleModal open={openScheduleModal}
        onClose={() => setOpenScheduleModal(false)}
        onSelect={handleScheduleSelect} />
    </Box>
  );
};

export default ChatInitiation;